import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Button } from '@mui/material';
import { useAppProviderStore } from 'store/appProviderCopyStore';

function Transcoder(props) {
  const { handleConfirmPublish, setTranscoderAproval } = props;
  const { activeStep, openTranscoder, setOpenTranscoder } =
    useAppProviderStore();

  return (
    <div>
      <Dialog
        open={openTranscoder}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle
          id="alert-dialog-title"
          style={{
            fontSize: 16,
            display: 'flex',
            justifyContent: 'flex-end',
          }}>
          {/* <CheckCircleOutlineIcon color="success" style={{ marginRight: 10 }} /> */}
          {/* {"O upload dos seguintes arquivos foi realizado com sucesso:"} */}
        </DialogTitle>
        <DialogContent style={{ padding: '5px 25px' }}>
          <DialogContentText id="alert-dialog-description">
            Enquanto você estiver preenchendo os demais dados, estaremos
            preparando a sua mídia com as legendas e áudios que você selecionou.
            Mas antes de avançar,{' '}
            <strong>
              deseja adicionar outros arquivos Áudio/Vídeo ou Legenda?
            </strong>
            {/* <List
              sx={{ width: "100%", bgcolor: "background.paper" }}
              component="nav"
              aria-labelledby="nested-list-subheader"
            >
              <ListItem>
                <strong>"Sim, quero adicionar"</strong>
              </ListItem>
              <ListItem>
                <strong>"Já inserir os arquivos Áudio/Vídeo ou Legenda"</strong>
              </ListItem>
            </List>  */}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{ display: 'flex', justifyContent: 'center', padding: 25 }}>
          <Button
            variant="outlined"
            style={{ width: 210, marginRight: 10 }}
            onClick={e => {
              setOpenTranscoder(false);
            }}>
            Sim, quero adicionar
          </Button>
          <Button
            variant="contained"
            style={{ width: 300, marginLeft: 10 }}
            onClick={e => {
              if (activeStep === 7) {
                let selectId = 'main';
                setTranscoderAproval(prevSelectedOptions => ({
                  ...prevSelectedOptions,
                  [selectId]: true,
                }));
                let selectId2 = 'trailer';
                setTranscoderAproval(prevSelectedOptions => ({
                  ...prevSelectedOptions,
                  [selectId2]: true,
                }));

                let selectId3 = 'accessibility';
                setTranscoderAproval(prevSelectedOptions => ({
                  ...prevSelectedOptions,
                  [selectId3]: true,
                }));
              }
              setOpenTranscoder(false);
              handleConfirmPublish();
            }}
            autoFocus>
            Não, já inseri os arquivos
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Transcoder;
